import React, {useMemo} from 'react';
import {useTheme} from '@mui/material';
import {Layout} from 'components/layout';

type Props = {
  spacing?: string | number;
  height?: string | number;
  colorx?: string;
};

const makeBorder = (colorx: string) => `0.5px solid ${colorx}`;

export const Bar: React.FC<Props> = ({spacing, height, colorx}) => {
  const {colors} = useTheme();
  const sx = useMemo(() => {
    return colorx
      ? {
          border: makeBorder(colorx),
        }
      : {
          border: makeBorder(colors.warmGreen),
        };
  }, [colorx, colors]);

  return (
    <Layout
      mx={spacing}
      height={height}
      flex={height === undefined ? 1 : undefined}
      sx={sx}
    />
  );
};
